// extracted by mini-css-extract-plugin
export default {"state":"EmptyState_state__xilZJ","title":"EmptyState_title__IYZtL"};